/**
 * scam-app.js — интерфейс /scam-check. Весь разбор в scam-engine.js.
 *
 * Решения экрана:
 *  1. НАСТОЯЩИЙ АДРЕС ССЫЛКИ ПОКАЗЫВАЕТСЯ КРУПНО И ОТДЕЛЬНО. Человек смотрит на
 *     начало ссылки, а ведёт она туда, что стоит после последней @ и до
 *     первого слэша.
 *  2. ВЕРДИКТА «БЕЗОПАСНО» НЕТ. Максимум — «известных признаков не нашлось», и
 *     рядом объяснение, почему это не разрешение переводить деньги.
 *  3. РАЗБОР ИДЁТ ПО МЕРЕ ВВОДА — кнопку «проверить» человек с открытым
 *     сообщением на втором экране искать не будет.
 *  4. НАЙДЕННОЕ ПОДСВЕЧИВАЕТСЯ В САМОМ ТЕКСТЕ. Список признаков без места в
 *     сообщении заставляет сопоставлять глазами; подсветка отвечает сразу.
 *  5. СООБЩЕНИЕ ЧАСТО ЕСТЬ ТОЛЬКО КАРТИНКОЙ (скриншот переписки, QR на
 *     листовке). Картинка читается на странице: QR — ZXing (`__qrDecode`),
 *     текст — общая дверь распознавания `OcrEngine`. Скачивание модели
 *     показывается честно, до ожидания.
 *
 * ⛔ Текст сообщения НЕ сохраняется ни в __toolSettings, ни в URL: это чужая
 * переписка, а URL уходит в журналы.
 */
(function () {
'use strict';

var BOOT = window.__SCAM || {};
var T = BOOT.T || {};
var CFG = BOOT.cfg || {};
var SLUG = 'scam-check';
var E = null;

function t(k, r) {
    var s = T[k];
    if (s == null) return k;
    /* По ГРАНИЦЕ имени: `:n` не должен съедать голову `:need`. */
    if (r) Object.keys(r).sort(function (a, b) { return b.length - a.length; }).forEach(function (n) {
        s = s.replace(new RegExp(':' + n + '(?![A-Za-z0-9_])', 'g'), function () { return String(r[n]); });
    });
    return s;
}
function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
}
function $(id) { return document.getElementById(id); }
function ae(ev, d) { try { if (window.__ae) window.__ae(ev, Object.assign({ slug: SLUG }, d || {})); } catch (_) { } }

var SVG = {
    alert: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.3 3.9L2 18a2 2 0 001.7 3h16.6a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0z"/><path d="M12 9v4M12 17h.01"/></svg>',
    stop: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7.9 2h8.2L22 7.9v8.2L16.1 22H7.9L2 16.1V7.9z"/><path d="M15 9l-6 6M9 9l6 6"/></svg>',
    help: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.1 9a3 3 0 015.8 1c0 2-3 3-3 3M12 17h.01"/></svg>',
    share: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"/></svg>'
};
var V_ICON = { scam: 'stop', likely: 'alert', suspicious: 'alert', unclear: 'help' };
var V_LEVEL = { unclear: 0, suspicious: 1, likely: 2, scam: 3 };

/* ── ввод ─────────────────────────────────────────────────────────────── */

var ta, out, lastResult = null, lastText = '', timer = 0, reported = '';

function schedule() {
    clearTimeout(timer);
    syncTools();
    timer = setTimeout(render, 180);
}

function syncTools() {
    var has = !!ta.value.trim();
    $('scClear').hidden = !has;
}

function setText(v, how) {
    ta.value = v;
    ta.dispatchEvent(new Event('input', { bubbles: true }));
    if (how) ae('feature_use', { f: 'input_' + how });
}

function appendText(v) {
    var cur = ta.value.trim();
    setText(cur ? cur + '\n' + v : v);
}

/* ── разбор ───────────────────────────────────────────────────────────── */

function render() {
    var text = ta.value || '';
    if (!text.trim()) {
        lastResult = null;
        showEmpty();
        return;
    }
    if (text === lastText && lastResult) return;
    lastText = text;
    var r = E.check(text);
    lastResult = r;

    var nodes = [verdictCard(r, text)];
    if (r.urls.length) nodes.push(urlCard(r));
    if (r.flags.length) nodes.push(flagsCard(r));
    nodes.push(actionsCard(r));

    out.textContent = '';
    nodes.forEach(function (n) { out.appendChild(n); });

    /* Одно событие на устоявшийся текст, а не на каждую букву. */
    clearTimeout(render._rep);
    render._rep = setTimeout(function () {
        var sig = r.verdict + '|' + r.flags.map(function (f) { return f.id; }).join(',');
        if (sig === reported) return;
        reported = sig;
        if (window.__aeToolComplete) {
            window.__aeToolComplete({ verdict: r.verdict, flags: r.flags.length, urls: r.urls.length,
                top: r.flags[0] ? r.flags[0].id : '', protective: r.protective ? 1 : 0 });
        }
    }, 1500);
}

function showEmpty() {
    var empty = $('scEmpty');
    out.textContent = '';
    if (empty) out.appendChild(empty);
}

function verdictCard(r, text) {
    var c = el('section', 'tc-panel sc-v v-' + r.verdict);
    var top = el('div', 'sc-v-top');
    var ico = el('span', 'sc-v-ico');
    ico.innerHTML = SVG[V_ICON[r.verdict]];
    ico.setAttribute('aria-hidden', 'true');
    top.appendChild(ico);
    var txt = el('div');
    txt.appendChild(el('h3', 'sc-v-t', t('v_' + r.verdict)));
    if (r.flags.length && r.verdict !== 'unclear') {
        var why = el('p', 'sc-v-why');
        var parts = t('v_reason').split(':flag');
        why.appendChild(document.createTextNode(parts[0] || ''));
        why.appendChild(el('span', null, t('f_' + r.flags[0].id)));
        if (parts[1]) why.appendChild(document.createTextNode(parts[1]));
        txt.appendChild(why);
    }
    txt.appendChild(el('p', 'sc-v-d', t('v_' + r.verdict + '_d')));
    top.appendChild(txt);
    c.appendChild(top);

    var scale = el('div', 'sc-scale');
    scale.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 4; i++) scale.appendChild(el('i', i <= V_LEVEL[r.verdict] ? 'on' : ''));
    c.appendChild(scale);
    var sl = el('div', 'sc-scale-l');
    sl.setAttribute('aria-hidden', 'true');
    sl.appendChild(el('span', null, t('scale_l')));
    sl.appendChild(el('span', null, t('scale_r')));
    c.appendChild(sl);

    if (r.verdict === 'unclear') c.appendChild(el('p', 'tc-note', t('unclear_note')));
    if (r.protective && (r.verdict === 'unclear' || r.verdict === 'suspicious')) c.appendChild(el('p', 'tc-msg', t('protective_note')));

    var hl = highlight(text, r);
    if (hl) {
        c.appendChild(el('p', 'sc-hl-l', t('hl_title')));
        c.appendChild(hl);
    }

    var act = el('div', 'sc-v-actions');
    var sh = el('button', 'tc-btn ghost sm');
    sh.type = 'button';
    sh.innerHTML = SVG.share;
    sh.appendChild(el('span', null, t('share_btn')));
    sh.addEventListener('click', function () { share(r); });
    act.appendChild(sh);
    c.appendChild(act);
    return c;
}

/* Подсветка найденных фрагментов прямо в тексте сообщения. Совпадения
   берутся из движка; ищутся без учёта регистра, пересечения сливаются. */
function highlight(text, r) {
    var spans = [];
    var low = text.toLowerCase();
    r.flags.forEach(function (f) {
        var needles = [];
        if (f.data && f.data.match) needles.push({ s: f.data.match, w: f.tier ? 3 : f.weight });
        if (f.url) {
            var shown = (r.urls.filter(function (u) { return u.url.raw === f.url; })[0] || {}).shown;
            if (shown) needles.push({ s: shown, w: f.tier ? 3 : f.weight });
        }
        needles.forEach(function (n) {
            var i = low.indexOf(String(n.s).toLowerCase());
            if (i >= 0) spans.push([i, i + n.s.length, n.w]);
        });
    });
    if (!spans.length) return null;
    spans.sort(function (a, b) { return a[0] - b[0]; });
    var merged = [];
    spans.forEach(function (s) {
        var last = merged[merged.length - 1];
        if (last && s[0] <= last[1]) { last[1] = Math.max(last[1], s[1]); last[2] = Math.max(last[2], s[2]); }
        else merged.push(s.slice());
    });
    var box = el('div', 'sc-hl');
    var pos = 0;
    merged.forEach(function (s) {
        if (s[0] > pos) box.appendChild(document.createTextNode(text.slice(pos, s[0])));
        box.appendChild(el('mark', s[2] >= 3 ? '' : 'w' + s[2], text.slice(s[0], s[1])));
        pos = s[1];
    });
    if (pos < text.length) box.appendChild(document.createTextNode(text.slice(pos)));
    return box;
}

function urlCard(r) {
    var c = el('section', 'tc-panel');
    var head = el('div', 'tc-head');
    head.appendChild(el('h3', 'tc-title', t('url_title')));
    c.appendChild(head);
    r.urls.forEach(function (u) {
        var bad = u.flags.some(function (f) { return f.tier; });
        var box = el('div', 'sc-url' + (bad ? ' bad' : ''));
        box.appendChild(el('p', 'sc-url-raw', u.shown || u.url.raw));
        if (!u.url.ok) {
            box.appendChild(el('p', 'tc-hint', t('url_unparsable')));
            c.appendChild(box);
            return;
        }
        box.appendChild(el('p', 'sc-url-l', t('url_real')));
        box.appendChild(el('p', 'sc-url-host', u.url.decodedHost || u.url.host));
        if (u.url.decodedHost && u.url.decodedHost !== u.url.host) {
            box.appendChild(el('p', 'tc-hint', t('url_decoded', { host: u.url.host })));
        }
        if (u.url.userinfo) {
            box.appendChild(el('p', 'sc-url-warn', t('url_userinfo', { shown: u.url.userinfo, real: u.url.host })));
        }
        var parts = el('div', 'sc-labels');
        var labels = u.url.decodedLabels || u.url.labels;
        labels.forEach(function (lbl, i) {
            var isReg = i >= labels.length - (u.url.regCount || 2);
            var chip = el('span', 'sc-label' + (isReg ? ' reg' : ''), lbl);
            if (E.scriptsIn(lbl).length > 1) chip.classList.add('mixed');
            parts.appendChild(chip);
            if (i < labels.length - 1) parts.appendChild(el('span', 'sc-dot', '.'));
        });
        box.appendChild(parts);
        box.appendChild(el('p', 'tc-note', t('url_labels_note')));

        var links = el('div', 'sc-url-links');
        if (CFG.whoisUrl && !/^\d/.test(u.url.host)) {
            var a1 = el('a', 'tc-btn ghost sm', t('url_whois'));
            a1.href = CFG.whoisUrl + '?domain=' + encodeURIComponent(u.url.registrable);
            a1.target = '_blank'; a1.rel = 'noopener';
            links.appendChild(a1);
        }
        if (CFG.redirectUrl && u.flags.some(function (f) { return f.id === 'shortener'; })) {
            var a2 = el('a', 'tc-btn ghost sm', t('url_redirect'));
            a2.href = CFG.redirectUrl + '?url=' + encodeURIComponent(u.url.raw);
            a2.target = '_blank'; a2.rel = 'noopener';
            links.appendChild(a2);
        }
        if (links.childNodes.length) box.appendChild(links);
        c.appendChild(box);
    });
    return c;
}

function tierLabel(f) {
    if (f.tier === 'absolute') return t('w_absolute');
    if (f.tier === 'decisive') return t('w_decisive');
    return t(f.weight >= 2 ? 'w_strong' : 'w_weak');
}

function flagsCard(r) {
    var c = el('section', 'tc-panel');
    var head = el('div', 'tc-head');
    head.appendChild(el('h3', 'tc-title', t('flags_title')));
    head.appendChild(el('span', 'tc-hint', String(r.flags.length)));
    c.appendChild(head);
    var list = el('ul', 'sc-flags');
    r.flags.forEach(function (f) {
        var li = el('li', 'sc-flag ' + (f.tier ? 't-' + f.tier : 'w' + f.weight));
        var h = el('div', 'sc-flag-h');
        h.appendChild(el('span', 'sc-flag-n', t('f_' + f.id)));
        h.appendChild(el('span', 'sc-flag-w', tierLabel(f)));
        li.appendChild(h);
        li.appendChild(el('p', 'sc-flag-d', t('f_' + f.id + '_d')));
        if (f.data && f.data.match) li.appendChild(el('code', 'sc-flag-m', '«' + f.data.match + '»'));
        else if (f.data && (f.data.decoded || f.data.host)) li.appendChild(el('code', 'sc-flag-m', f.data.decoded || f.data.host));
        if (f.data && f.data.brand && f.data.real) {
            li.appendChild(el('p', 'sc-flag-x', t(f.data.how === 'typo' ? 'f_brand_typo' : 'f_brand_real', { real: f.data.real })));
        }
        if (f.boosted) li.appendChild(el('p', 'sc-flag-x', t('boosted_note')));
        list.appendChild(li);
    });
    c.appendChild(list);
    return c;
}

function actionsCard(r) {
    var c = el('section', 'tc-panel');
    var head = el('div', 'tc-head');
    head.appendChild(el('h3', 'tc-title', t('do_title')));
    c.appendChild(head);
    var danger = r.verdict === 'scam' || r.verdict === 'likely';
    var ids = danger
        ? ['stop', 'hang_up', 'call_back', 'never_codes', 'no_remote', 'report', 'tell_family']
        : ['verify_channel', 'type_yourself', 'never_codes', 'ask_someone'];
    var ol = el('ol', 'sc-do');
    ids.forEach(function (id) {
        var li = el('li');
        li.appendChild(el('b', null, t('do_' + id)));
        li.appendChild(el('span', null, ' — ' + t('do_' + id + '_d')));
        ol.appendChild(li);
    });
    c.appendChild(ol);
    if (danger) {
        var p = el('p', 'tc-msg bad', t('do_money_note'));
        c.appendChild(p);
    }
    return c;
}

/* ── отправить разбор близкому ────────────────────────────────────────── */

function shareText(r) {
    var lines = [t('share_head', { verdict: t('v_' + r.verdict) })];
    if (r.flags.length) {
        lines.push(t('share_signs'));
        r.flags.slice(0, 6).forEach(function (f) { lines.push('• ' + t('f_' + f.id)); });
    }
    r.urls.forEach(function (u) { if (u.url.ok) lines.push(t('url_real') + ' ' + (u.url.decodedHost || u.url.host)); });
    lines.push(t('share_foot'));
    lines.push(location.origin + location.pathname);
    return lines.join('\n');
}

function share(r) {
    var text = shareText(r);
    ae('feature_use', { f: 'share', verdict: r.verdict });
    if (navigator.share) {
        navigator.share({ text: text }).catch(function (e) {
            if (e && e.name === 'AbortError') return;
            copy(text);
        });
        return;
    }
    copy(text);
}

function copy(text) {
    var done = function () { if (window.__toast) window.__toast(t('share_copied'), 'success'); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, function () { fallbackCopy(text); done(); });
    } else { fallbackCopy(text); done(); }
}
function fallbackCopy(text) {
    var x = el('textarea');
    x.value = text;
    x.setAttribute('readonly', '');
    x.style.position = 'fixed';
    x.style.opacity = '0';
    document.body.appendChild(x);
    x.select();
    try { document.execCommand('copy'); } catch (_) { }
    x.remove();
}

/* ── вставить из буфера ───────────────────────────────────────────────── */

function pasteFromClipboard() {
    if (!navigator.clipboard) return;
    /* Сначала картинка: скриншот переписки в буфере — обычный случай на
       телефоне. clipboard.read есть не везде; readText — почти везде. */
    var tryText = function () {
        if (!navigator.clipboard.readText) { imgMsg(t('paste_denied'), true); return; }
        navigator.clipboard.readText().then(function (s) {
            if (!s || !s.trim()) { imgMsg(t('paste_empty'), true); return; }
            imgMsg(null);
            setText(s, 'paste');
            ta.focus();
        }, function () { imgMsg(t('paste_denied'), true); });
    };
    if (navigator.clipboard.read) {
        navigator.clipboard.read().then(function (items) {
            for (var i = 0; i < items.length; i++) {
                var type = items[i].types.filter(function (x) { return /^image\//.test(x); })[0];
                if (type) { return items[i].getType(type).then(function (b) { readImage(b, 'paste'); }); }
            }
            tryText();
        }, tryText);
    } else tryText();
}

/* ── картинка: QR и текст ─────────────────────────────────────────────── */

function imgMsg(text, bad, progress) {
    var m = $('scImgMsg');
    if (!text) { m.hidden = true; m.textContent = ''; return; }
    m.hidden = false;
    m.className = 'sc-imgmsg' + (bad ? ' bad' : '');
    m.textContent = '';
    if (progress != null) {
        var bar = el('span', 'sc-bar');
        var b = el('b');
        b.style.width = Math.round(progress * 100) + '%';
        bar.appendChild(b);
        m.appendChild(bar);
    }
    m.appendChild(el('span', null, text));
}

function loadScript(src) {
    return new Promise(function (res, rej) {
        var s = document.createElement('script');
        s.src = src;
        s.onload = function () { res(); };
        s.onerror = function () { rej(new Error('script_load_failed')); };
        document.head.appendChild(s);
    });
}

var busyImage = false;
async function readImage(blob, how) {
    if (busyImage || !blob) return;
    if (blob.size > 25 * 1024 * 1024) { imgMsg(t('img_big'), true); return; }
    busyImage = true;
    ae('feature_use', { f: 'image', how: how, mb: Math.round(blob.size / 1e5) / 10 });
    imgMsg(t('img_reading'), false, 0.05);
    var qrTexts = [], ocrText = '';
    try {
        /* 1. QR — быстро и без моделей. */
        try {
            if (!window.__qrDecode && CFG.qrSrc) await loadScript(CFG.qrSrc);
            if (window.__qrDecode && window.__qrDecode.isSupported()) {
                var res = await window.__qrDecode.fromFile(blob, { maxSymbols: 4 });
                (res || []).forEach(function (x) { if (x && x.text) qrTexts.push(x.text); });
            }
        } catch (_) { }

        /* 2. Текст. Модель скачивается один раз — называем цену до ожидания. */
        if (window.OcrEngine) {
            var mb = 0;
            try { mb = await window.OcrEngine.downloadMb(CFG.ocrLang); } catch (_) { }
            imgMsg(mb > 0 ? t('img_model', { mb: Math.round(mb) }) : t('img_reading'), false, 0.12);
            var eng = await window.OcrEngine.open(CFG.ocrLang, {
                slug: SLUG,
                onProgress: function (p) { imgMsg(mb > 0 ? t('img_model', { mb: Math.round(mb) }) : t('img_reading'), false, 0.12 + 0.6 * (p || 0)); }
            });
            try {
                imgMsg(t('img_reading'), false, 0.8);
                var bmp = await createImageBitmap(blob);
                var data = await eng.recognize(bmp, { orient: true });
                ocrText = (data && data.text || '').replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
            } finally { try { eng.close(); } catch (_) { } }
        }
    } catch (e) {
        if (!qrTexts.length) {
            imgMsg(t('img_fail', { msg: String((e && e.message) || e).slice(0, 80) }), true);
            if (window.__aeDiagnostic) window.__aeDiagnostic({ issue: 'image_read_failed', msg: String((e && e.message) || e).slice(0, 120) });
            busyImage = false;
            return;
        }
    }
    busyImage = false;
    var add = [];
    /* Квадраты QR-кода распознаватель текста читает как «— □». Текст, в
       котором меньше восьми букв, — не сообщение, а шум картинки. */
    var letters = (ocrText.match(/\p{L}/gu) || []).length;
    if (ocrText && letters >= 8) add.push(ocrText); else ocrText = '';
    qrTexts.forEach(function (q) { if (add.join('\n').indexOf(q) < 0) add.push(q); });
    if (!add.length) { imgMsg(t('img_nothing'), true); ae('feature_use', { f: 'image_empty' }); return; }
    appendText(add.join('\n'));
    imgMsg(qrTexts.length && ocrText ? t('img_both') : qrTexts.length ? t('img_qr') : t('img_text'));
    ae('feature_use', { f: 'image_ok', qr: qrTexts.length, chars: ocrText.length });
}

function pickImage() {
    var inp = document.createElement('input');
    inp.type = 'file';
    inp.accept = 'image/*';
    inp.addEventListener('change', function () {
        if (inp.files && inp.files[0]) readImage(inp.files[0], 'pick');
    });
    inp.click();
}

/* ── кодовое слово ────────────────────────────────────────────────────── */

function bindCodeword() {
    var root = $('scRoot');
    $('scCwBtn').addEventListener('click', function () {
        var w;
        try { w = E.codeword(CFG.locale); }
        catch (e) { if (window.__toast) window.__toast(t('cw_no_random'), 'error'); return; }
        var box = $('scCw');
        box.textContent = w;
        box.hidden = false;
        $('scCwHow').hidden = false;
        $('scCwPrint').hidden = false;
        $('scPrintWord').textContent = w;
        ae('feature_use', { f: 'codeword' });
    });
    $('scCwPrint').addEventListener('click', function () {
        root.classList.add('sc-printing');
        var off = function () { root.classList.remove('sc-printing'); window.removeEventListener('afterprint', off); };
        window.addEventListener('afterprint', off);
        ae('feature_use', { f: 'codeword_print' });
        window.print();
        setTimeout(off, 1500);
    });
}

/* ── старт ────────────────────────────────────────────────────────────── */

function boot() {
    ta = $('scText');
    out = $('scOut');
    if (!ta || !out) return;
    E = window.ScamEngine;
    if (!E) {
        out.textContent = '';
        var c = el('section', 'tc-panel');
        c.appendChild(el('p', 'tc-msg bad', t('load_error')));
        out.appendChild(c);
        return;
    }

    ta.addEventListener('input', schedule);
    /* Автовысота там, где нет field-sizing:content. */
    if (!(window.CSS && CSS.supports && CSS.supports('field-sizing', 'content'))) {
        ta.addEventListener('input', function () {
            ta.style.height = 'auto';
            ta.style.height = Math.min(340, Math.max(ta.scrollHeight, 150)) + 'px';
        });
    }

    if (navigator.clipboard && (navigator.clipboard.readText || navigator.clipboard.read)) {
        $('scPaste').hidden = false;
        $('scPaste').addEventListener('click', pasteFromClipboard);
    }
    $('scImage').addEventListener('click', pickImage);
    $('scClear').addEventListener('click', function () {
        setText('');
        imgMsg(null);
        ta.focus();
    });

    /* Картинка вставкой (Ctrl+V скриншота) и перетаскиванием. */
    ta.addEventListener('paste', function (e) {
        var items = (e.clipboardData && e.clipboardData.items) || [];
        for (var i = 0; i < items.length; i++) {
            if (items[i].kind === 'file' && /^image\//.test(items[i].type)) {
                e.preventDefault();
                readImage(items[i].getAsFile(), 'paste_key');
                return;
            }
        }
    });
    var field = $('scField');
    ['dragenter', 'dragover'].forEach(function (ev) {
        field.addEventListener(ev, function (e) {
            if (e.dataTransfer && [].indexOf.call(e.dataTransfer.types || [], 'Files') >= 0) { e.preventDefault(); field.classList.add('drag'); }
        });
    });
    ['dragleave', 'drop'].forEach(function (ev) { field.addEventListener(ev, function () { field.classList.remove('drag'); }); });
    field.addEventListener('drop', function (e) {
        var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (f && /^image\//.test(f.type)) { e.preventDefault(); readImage(f, 'drop'); }
    });

    document.querySelectorAll('.sc-ex-b').forEach(function (b) {
        b.addEventListener('click', function () {
            setText(t('ex_' + b.getAttribute('data-ex')), 'example');
            /* Прокрутки нет намеренно: результат рядом с полем (или сразу под
               ним), и прыжок страницы под пальцем ничего не улучшает. */
        });
    });

    bindCodeword();
    $('scMoney').addEventListener('toggle', function () { if ($('scMoney').open) ae('feature_use', { f: 'money_drawer' }); });

    syncTools();
    if (ta.value.trim()) render();
    if (window.__stage) window.__stage('ready');
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();

})();
